import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import CourseCombo from '../combos/CourseCombo';
import TeacherCombo from '../combos/TeacherCombo';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from "primereact/radiobutton";
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Col, Container, Form, Row } from 'react-bootstrap';
import StudentCombo from '../combos/StudentCombo';
import { responsivePropType } from 'react-bootstrap/esm/createUtilityClasses';
import PrintGradeSheet from '../school/PrintGradeSheet';
import PrintDisiplineSheet from '../school/PrintDisiplineSheet';
import PrintGradeSheetDescriptional from '../school/PrintGradeSheetDescriptional';
import { PDFDownloadLink } from '@react-pdf/renderer';


export default function StudentGradeSheet(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [comboVisible, setComboVisible] = useState(false);
  const [scoreVisible, setScoreVisible] = useState(false);
  const [btnVisible, setBtnVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDescriptional, setIsDescriptional] = useState(false);
  const [student, setStudent] = useState(null);
  const [targetStudentId, setTargetStudentId] = useState("");
  const [schoolClass, setSchoolClass] = useState(null);

  const [linkVisible, setLinkVisible] = useState(false); 
  const [pdfFileIsReady, setPdfFileIsReady] = useState(false);
  const [gradeSheetType, setGradeSheetType] = useState(0);
        
  const [gradeSheets, setGradeSheets] = useState([]);

  useEffect(() => {
    var user = util.getCurrentUser();
    if(user.Role === 5){
      setScoreVisible(true);
      setComboVisible(false);
      setTargetStudentId(user.UserId);
      setBtnVisible(true);
      loadGradeSheet(user.UserId, 1);
    }
    else if(user.Role === 6){
      setComboVisible(true);
    }
  }, []);

  const onStudentSelected = function(value){
    setScoreVisible(false);
    setLoading(false);
    console.log("student", value)
    var hasStu = false;
    if(value)if(value.id) hasStu = true;
    if(hasStu){
      setTargetStudentId(value.id);
    }
    else{
      setTargetStudentId("");
    }
    
    setStudent(value);
    setBtnVisible(hasStu);
    setScoreVisible(hasStu);

  }
  const printGradeSheet = function(studentId, schoolClassId, type){
    if(type == 3){
      var url = config.Client + "/school/disipline/grade-sheet/print";
      url += "?studentId=" + studentId;
      url += "&schoolClassId=" + schoolClassId;
      window.open(url);
      return;
    }
    setLinkVisible(true);
    setPdfFileIsReady(false);
    setGradeSheetType(type);
    var params = {login:util.getTrustedUser(), schoolClassId:schoolClassId, studentId:studentId, sheetType:type};
    var url = config.Server+`/school/month/grade-sheet/get`;
    console.log("params is>", params);
    console.log("url is>", url);    
    axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            
            if(response.state === "ok"){
                response = response.data;
                console.log(response);
                var gss = response;
                if(type == 1){
                  for(var g=0;g<gss.length;g++){
                    for(var c=gss[g].courses.length-1;c>=0;c--){
                      var found = false;
                      for(var i=0;i<gss[g].courses[c].scores.length;i++){
                        if(gss[g].courses[c].scores[i].isValid){
                          found = true;
                          break;
                        }
                      }
                      if(!found){
                        gss[g].courses.splice(c, 1);
                      }
                    }
                  }
                }
                var max = 18;
                for(var i=0;i<gss.length;i++){
                  gss[i]["emptyRows"] = [];
                  console.log("(i, len)->" + "(" + i + ", " + gss[i].courses.length + ")");
                  if(gss[i].courses.length < max) {
                    var rem = max-gss[i].courses.length;
                    console.log("(i, rem)->" + "(" + i + ", " + rem + ")");
                    gss[i]["emptyRows"] = Array.from({length:(rem)});
                  }
                }
                console.log("grade sheets is> ", gss);
                setGradeSheets(gss);
                
                setPdfFileIsReady(true);
                
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setLinkVisible(false);
                if(props.onComplete) props.onComplete(false, response.message);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setLinkVisible(false);
            if(props.onComplete) props.onComplete(false, error.code + "," + error.message);
        });

  }
  const loadGradeSheet = function(stuId, type){
    printGradeSheet(stuId, "", type) ;  
  }
  return (
    <>
      <Row>
    {
      comboVisible?
        <Col md={3}>
          <StudentCombo value={student} onChange={(value)=>{ onStudentSelected(value.itemValue)}}  returnFullItem={true}/>
        </Col>
      :<></>
    }
        <Col md={3} style={{paddingTop:"30px"}}>
          <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
            {btnVisible?<Button label="مشاهده کارنامه" icon="pi pi-check" onClick={()=>{loadGradeSheet(targetStudentId, 1)}} severity="success" iconPos="right" loading={loading} />: <></>}
          </div>          
        </Col>
        <Col md={3} style={{paddingTop:"30px"}}>
          <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
            {btnVisible?<Button label="مشاهده کارنامه توصیفی" icon="pi pi-check" onClick={()=>{loadGradeSheet(targetStudentId, 2)}} severity="primary" iconPos="right" loading={loading} />: <></>}
          </div>          
        </Col>
      </Row>
      {
        scoreVisible?
        <div>
          {
            loading?
            <>loading...</>
            :
            <>
            <Container fluid>

            {
              linkVisible?
              <div className="" style={{ width:"calc(100% - 0px)", marginTop:"50px"}}>
                <div style={{backgroundColor:'rgba(255, 254, 211, 1)', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
                    <Row>
                      <Col md={3}>
                        لینک دانلود کارنامه:
                      </Col>
                    </Row>
                    <Row style={{marginTop:"10px", paddingBottom:"10px"}}>
                      {
                        gradeSheetType == 1?
                        <Col md={3}>
                          {
                            pdfFileIsReady?
                            <PDFDownloadLink  style={{textDecoration:"0px"}}
                              document={<PrintGradeSheet 
                                data={gradeSheets} 
                                />} fileName={"Karname_"+util.generateRandomUString(10)+".pdf"}>
                                  <label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود کارنامه!</label>
                              {
                                // ({ blob, url, loading, error }) =>
                                // loading ? 'درحال آماده سازی فایل...' : <><label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود برنامه هفتگی!</label></>
                              }
                            </PDFDownloadLink>
                            :
                            <>درحال آماده سازی فایل...</>
                          }
                          
                        </Col>
                        :
                        <></>
                      }
                      {
                        gradeSheetType == 2?
                        <Col md={3}>
                          {
                            pdfFileIsReady?
                            <PDFDownloadLink  style={{textDecoration:"0px"}}
                              document={<PrintGradeSheetDescriptional 
                                data={gradeSheets} 
                                />} fileName={"Karname_decriptional_"+util.generateRandomUString(10)+".pdf"}>
                                  <label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود کارنامه توصیفی!</label>
                              {
                                // ({ blob, url, loading, error }) =>
                                // loading ? 'درحال آماده سازی فایل...' : <><label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود برنامه هفتگی!</label></>
                              }
                            </PDFDownloadLink>
                            :
                            <>درحال آماده سازی فایل توصیفی...</>
                          }
                          
                        </Col>
                        :
                        <></>
                      }
                      {
                        gradeSheetType == 3?
                        <Col md={3}>
                          {
                            pdfFileIsReady?
                            <PDFDownloadLink  style={{textDecoration:"0px"}}
                              document={<PrintDisiplineSheet 
                                data={gradeSheets} 
                                />} fileName={"Karname_decriptional_"+util.generateRandomUString(10)+".pdf"}>
                                  <label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود کارنامه تربیتی!</label>
                              {
                                // ({ blob, url, loading, error }) =>
                                // loading ? 'درحال آماده سازی فایل...' : <><label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود برنامه هفتگی!</label></>
                              }
                            </PDFDownloadLink>
                            :
                            <>درحال آماده سازی فایل تربیتی...</>
                          }
                          
                        </Col>
                        :
                        <></>
                      }
                    </Row>
                </div>
              </div>
              :<></>
            }
            </Container>
            </>
          }
        </div>
        :
        <></>
      }
    <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
    </>
  );
}
